/**
 * In this file we handel to show the OTP popup screen and OTP Verify logic
 **/
import Modal from "react-bootstrap/Modal";
import { useState, useRef, useEffect } from "react";
import Countdown from "react-countdown";
import ApiService from "./../../services/ApiService";
import { validateOTP } from "./../../services/ValidationService";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

function Otpmodal(props) {
  //Intial state declaraction
  const [values, setValues] = useState(new Array(4).fill(""));
  const [showTimer, setShowTimer] = useState(true);
  const [resendOtp, setResendOtp] = useState(false);
  const [otpForm, setOtpForm] = useState({ valid: false });
  const navigate = useNavigate();
  const role = sessionStorage.getItem("role");
  const [targetDate, setTargetDate] = useState(new Date().getTime() + 60000); // Set initial target date to 60 seconds from now

  //Resend OTP
  const resendOTP = async () => {
    setValues(["", "", "", ""]);
    await ApiService.resendOTP({ user: props?.userData?.id }).then(
      (response) => {
        if (response.status === 200) {
          setTargetDate(new Date().getTime() + 60000); // Set new target date to 60 seconds from now
          setShowTimer(true);
          setResendOtp(false);
          toast.success("OTP Resend successfully");
        }
      },
      (error) => {
        console.log(error);
      }
    );
  };

  /**
   * Trigger when the timer get close (00:00)
   * @e we get the event details from the click action
   **/
  const onComplete = (e) => {
    setShowTimer(false);
    setResendOtp(true);
  };

  //To handel while to move the cursor to next empty field while current field have value
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

  //Reset the State value every time the modal open
  useEffect(() => {
    setValues(["", "", "", ""]);
    setShowTimer(true);
    setResendOtp(false);
    setOtpForm({ valid: false });
    setTargetDate(new Date().getTime() + 60000);
  }, [props]);

  /**
   * To handle input change function
   * @e we get the event details from change action
   * @index pass the Array indexOf on the UI screen
   **/
  const handleChange = async (e, index) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && value.length <= 1) {
      setValues((prevValues) => {
        const newValues = [...prevValues];
        newValues[index] = value;
        return newValues;
      });
      if (value.length === 1 && index < inputRefs.length - 1) {
        inputRefs[index + 1].current.focus();
      }
    } else if (value.length === 0) {
      setValues((prevValues) => {
        const newValues = [...prevValues];
        newValues[index] = "";
        return newValues;
      });
    }
  };

  /**
   * Handle key down events for backspace functionality
   * @e we get the event details from key down action
   * @index pass the Array indexOf on the UI screen
   **/
  const handleKeyDown = (e, index) => {
    if (e.key === 'Backspace' || e.key === 'Delete') {
      e.preventDefault();
      
      setValues((prevValues) => {
        const newValues = [...prevValues];
        
        // If current input has value, clear it
        if (newValues[index] !== "") {
          newValues[index] = "";
        } else if (index > 0) {
          // If current input is empty, move to previous input and clear it
          newValues[index - 1] = "";
          inputRefs[index - 1].current.focus();
        }
        
        return newValues;
      });
    }
  };

  //Validation setOtpForm every time  values change
  useEffect(() => {
    (async () => {
      const isValid = await validateOTP(values);
      isValid === true
        ? setOtpForm({ valid: true })
        : setOtpForm({ valid: false });
    })();
  }, [values]);

  /**
   * To handle login submit function
   * @e we get the event details from the form submit event
   **/
  const handelSubmit = async (e) => {
    e.preventDefault();
    if (validateOTP(values)) {
      var otpValue = Object.values(values).join("");
      ApiService.verifyOTP({ otp: otpValue, user: props?.userData?.id }).then(
        (response) => {
          if(response.status===200){        
            sessionStorage.setItem('userEPK',response.data.userEPK);
            sessionStorage.setItem('userId', response.data.userId);
            sessionStorage.setItem('source',props?.userData?.source);
            sessionStorage.setItem('userRole',role);
            navigate('/create-password');
            props.handleClose({});
            toast.success("OTP verify successfully");
        }else{
            toast.error(response?.data?.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    }
  };

  return (
    <Modal
      show={props?.userData?.show}
      onHide={props.handleClose}
      backdrop="static"
      keyboard={false}
      size="md"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>Enter OTP</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {/*OTP Form*/}
        <form>
          <div className="card p-2 text-center">
            <div className="inputs d-flex flex-row justify-content-center mt-2">
              {values.map((value, index) => (
                <input
                  key={index}
                  ref={inputRefs[index]}
                  className="m-2 text-center form-control rounded"
                  type="text"
                  maxLength="1"
                  value={value}
                  onChange={(e) => handleChange(e, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                />
              ))}
            </div>
            <div>
              {/*Import Countdown Module*/}
              {showTimer && (
                <Countdown
                  onComplete={onComplete}
                  className="bootstrap-timer"
                  format="mm:ss"
                  date={targetDate}
                  renderer={({ seconds }) => (
                    <span>{`${Math.floor(seconds / 60)
                      .toString()
                      .padStart(2, "0")}:${(seconds % 60)
                      .toString()
                      .padStart(2, "0")}`}</span>
                  )}
                />
              )}
              <div className="mt-4">
                {/*Handel the Verify Button activity and disabled*/}
                {!resendOtp && (
                  <button
                    disabled={!otpForm.valid}
                    onClick={handelSubmit}
                    type="submit"
                    className="btn btn-success px-4"
                  >
                    Verify
                  </button>
                )}
                {/*Handel the Resend Button show and hide*/}
                {resendOtp && (
                  <button
                    onClick={resendOTP}
                    type="button"
                    className="btn btn-success px-4"
                  >
                    Resend OTP
                  </button>
                )}
              </div>
            </div>
          </div>
        </form>
        {/*End OTP Form*/}
      </Modal.Body>
    </Modal>
  );
}

export default Otpmodal;
